import React, { Component } from "react";
import { InjectedFormikProps, withFormik } from "formik";
import * as Yup from "yup";
import InputWithLabel from "../../../common/form/InputWithLabel";
import BackButton from "../../../common/button/BackButton";
import SubmitButton from "../../../common/form/SubmitButton";
import { History } from "history";
import swal from "sweetalert";
import { onFailAction } from "../../../common/swal/SwalCommon";
import DistrictService from "../../../../services/district/DistrictService";

interface Props {
  id: string;
  history: History;
}
interface State {
  code: string;
  fullname: string;
  short_name: string;
  start_date: string;
  end_date: string;
}

class UpdateUserForm extends Component<InjectedFormikProps<Props, State>> {
  state = {
    permissions: {},
    agency: {},
    code: '',
    short_name: '',
    start_date: '',
    end_date: '',
  };

  componentDidMount() {

    this.props.setFieldValue("valid_at", '');
    this.props.setFieldValue("release_at", '');
    this.getDataUpdate();
  }

  getDataUpdate = async () => {
    const service = new DistrictService();
    const result = await service.getDistrict(this.props.id);
    if (result && result.status === 200) {
      const {
        code,
        short_name,
        fullname,
        start_date,
        end_date,
      } = result.data;

      this.props.setValues({
        code,
        short_name,
        fullname,
        start_date,
        end_date
      } as Pick<State, keyof State>);


      let value_start_date = '';
      if (result.data.start_date !== null) {
        value_start_date = result.data.start_date;
      }
      let value_end_date = '';
      if (result.data.end_date !== null) {
        value_end_date = result.data.end_date;
      }
      this.props.setFieldValue("start_date", value_start_date);
      this.props.setFieldValue("end_date", value_end_date);
    }
  };

  onChangeSelectStartDate = (date, dateString) => {
    this.props.setFieldValue("start_date", dateString);
  };

  onChangeSelectEndDate = (date, dateString) => {
    this.props.setFieldValue("end_date", dateString);
  };



  render() {
    const {
      code,
      fullname,
    } = this.props.values;

    return (
      <form>
        <div className="input-group">
          <InputWithLabel
            name="code"
            label="Mã quận huyện"
            wrapClass="col-md-4 form-group"
            onChangeValue={this.props.handleChange}
            value={code}
            error={this.props.errors.code}
            isRequired={true}
          />
          <InputWithLabel
              name="fullname"
              label="Tên quận huyện"
              wrapClass="col-md-4 form-group"
              onChangeValue={this.props.handleChange}
              value={fullname}
              error={this.props.errors.fullname}
              isRequired={true}
          />
        </div>
        <div className="input-group d-flex justify-content-center p-5">
          <BackButton history={this.props.history} url='/quan-huyen'/>
          <SubmitButton onClick={this.props.handleSubmit} />
        </div>
      </form>
    );
  }
}

const userUpdateForm = withFormik<Props, State>({
  validateOnBlur: false,
  validateOnChange: false,
  enableReinitialize: true,
  mapPropsToValues: () => ({
    code : "",
    short_name : "",
    fullname : "",
    start_date : "",
    end_date : "",
  }),
  validationSchema: Yup.object().shape({
    code: Yup.string().required("Tên phần mềm không được bỏ trống."),
    fullname: Yup.string().required("Số phần mềm không được bỏ trống.")
  }),
  handleSubmit: async (values, { setSubmitting, props, setErrors }) => {
    setSubmitting(false);
    const service = new DistrictService();
    const result = await service.updateDistrict({ ...values, permissions: '', id: props.id });
    if (result && result.status === 200) {
      swal({
        title: "Thành công!",
        text: "Cập nhật thành công!",
        icon: "success",
        dangerMode: false
      }).then(function () {
        props.history.goBack();
      });
    } else if (result.status === 1) {
      setErrors(result.errors);
    } else {
      onFailAction(result.errors);
    }
  },

})(UpdateUserForm);

export default userUpdateForm;
